import React, { useState, useEffect } from 'react';
import { FaSearch } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

export default function AppModalVisualization({ arquivo }: any) {

  const [show, setShow] = useState(false);
  const [fileType, setFileType] = useState('');

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true)
  };



  useEffect(() => {
    const file = arquivo.url.split('.')
    setFileType(file[file.length - 1].toUpperCase() || '')

  }, [])

  return (
    <>
      {(['PNG', 'JPG', 'JPEG', 'PDF'].includes(fileType)) && (
        <>
          <FaSearch onClick={handleShow} title='Visualizar' className='m-2 hover-icon' />
          <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            fullscreen={true}

          >
            <Modal.Header>
              <Modal.Title>{arquivo?.label}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {fileType === 'PDF' ?
                <iframe
                  src={arquivo?.url}
                  style={{ minHeight: '400px' }}
                  className='h-100 w-100'
                ></iframe>
                :
                <img src={arquivo?.url} className='h-100 w-100' />
              }
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>Fechar</Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  )
}
